import React from "react";
import { useIntl } from "react-intl";

import {
  SortDirection,
  TableCell,
  Tooltip,
  TableSortLabel,
} from "@mui/material";

type Props = {
  headItems: { [key: string]: string };
  sortable: {
    orders: { [key: string]: SortDirection | undefined };
    changeSort: Function;
  };
};

function SortableTableHeader({ headItems, sortable }: Props): JSX.Element {
  const { formatMessage } = useIntl();
  const orders = sortable.orders || {};

  function sortHandler(item: string): Function {
    return () => {
      // desc --> asc --> desc --> asc ...
      const orderFlow = {
        "": "desc",
        desc: "asc",
        asc: "desc",
      };

      // We reset previous orders and set the new one with its value
      const newOrders = Object.keys(orders).reduce((currentOrders, key) => {
        return {
          ...currentOrders,
          [key]: item === key ? orderFlow[orders[item] || ""] : "",
        };
      }, {});

      sortable?.changeSort(newOrders);
    };
  }

  return (
    <>
      {Object.keys(headItems || {}).map((item) => {
        if (item in orders) {
          const direction = orders[item];

          return (
            <TableCell key={item} sortDirection={orders?.[item] || false}>
              <Tooltip
                title={formatMessage({ id: "components.table.trier" })}
                enterDelay={300}
              >
                <TableSortLabel
                  id={`table-head-item-${item}`}
                  active={direction !== false}
                  // @ts-ignore
                  direction={orders[item] ? orders[item] : undefined}
                  onClick={sortHandler(item)}
                >
                  {headItems[item]}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          );
        }

        return <TableCell key={item}>{headItems[item]}</TableCell>;
      })}
    </>
  );
}

export default SortableTableHeader;
